/**
 * gut-quiz-v2.js
 * Re:your gut — Gut Archetype Quiz v2
 * Upload to: assets/ in Shopify code editor
 *
 * Loaded by gut-quiz-v2.liquid via:
 *   <script src="{{ 'gut-quiz-v2.js' | asset_url }}" defer>
 *
 * Per-instance config is read from window.RYGQuizV2[sectionId]
 * so multiple instances on one page are fully isolated.
 */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     QUIZ QUESTIONS & SCORING
  ═══════════════════════════════════════════════════════════ */

  var QUESTIONS = [
    {
      id: 1,
      text: 'Which of these feels most familiar lately?',
      hint: 'Select all that apply.',
      type: 'multi',
      options: [
        { text: 'I bloat after eating',                              scores: { fermenter:3, stalled:1 } },
        { text: 'My stomach looks or feels distended by end of day', scores: { fermenter:3 } },
        { text: 'I feel gassy or full of pressure',                  scores: { fermenter:3 } },
        { text: 'Food feels like it just sits there',                scores: { stalled:3, reflux:2 } },
        { text: 'I feel overly full quickly',                        scores: { stalled:3, reflux:1 } },
        { text: 'My digestion feels slow or sluggish',               scores: { stalled:3, fermenter:1 } },
        { text: 'I struggle with constipation',                      scores: { stalled:3, fermenter:1 } },
        { text: 'My digestion feels inconsistent',                   scores: { reactive:2, stalled:1 } },
        { text: 'Certain foods seem to trigger symptoms',            scores: { reactive:3 } },
        { text: 'My symptoms feel unpredictable',                    scores: { reactive:3 } },
        { text: 'Stress seems to affect my digestion',               scores: { reactive:3 } },
        { text: 'I feel tired or foggy after eating',                scores: { reactive:1, rebuilder:1 } },
        { text: 'I often feel inflamed, uncomfortable, or \u201coff\u201d', scores: { rebuilder:1 } },
        { text: 'My symptoms tend to worsen as the day goes on',     scores: { fermenter:2, stalled:1 } }
      ]
    },
    {
      id: 2,
      text: 'When do you notice your symptoms the most?',
      hint: 'Select all that apply.',
      type: 'multi',
      options: [
        { text: 'After meals',                  scores: { fermenter:2, stalled:1, reflux:1 } },
        { text: 'Later in the day',             scores: { fermenter:2, stalled:1 } },
        { text: 'At night',                     scores: { reflux:4 } },
        { text: 'After carbohydrates or sugar', scores: { fermenter:4 } },
        { text: 'During stressful periods',     scores: { reactive:3 } },
        { text: 'While traveling',              scores: { reactive:2 } },
        { text: 'Around hormonal shifts',       scores: { reactive:2 } },
        { text: 'After alcohol',                scores: { reflux:1, reactive:1 } },
        { text: 'After antibiotics',            scores: { rebuilder:3, reactive:1 } },
        { text: 'Randomly throughout the day',  scores: { reactive:3 } },
        { text: 'In the morning',               scores: { stalled:1, reflux:2 } },
        { text: 'Almost all the time',          scores: { rebuilder:2, fermenter:1, stalled:1, reactive:1 } }
      ]
    },
    {
      id: 3,
      text: 'Do any of these upper digestive symptoms sound familiar?',
      hint: 'Select all that apply. Choose \u201cNone of these\u201d if not applicable.',
      type: 'multi',
      options: [
        { text: 'Burning in my chest or throat',             scores: { reflux:5 } },
        { text: 'Reflux or food coming back up',             scores: { reflux:5 } },
        { text: 'Pressure or discomfort after meals',        scores: { reflux:3, stalled:1, fermenter:1 } },
        { text: 'Symptoms feel worse lying down',            scores: { reflux:5 } },
        { text: 'Frequent throat clearing',                  scores: { reflux:4 } },
        { text: 'Sour taste in my mouth',                    scores: { reflux:5 } },
        { text: 'I feel overly full after small meals',      scores: { reflux:2, stalled:2 } },
        { text: 'I rely on antacids or reflux medications',  scores: { reflux:4, rebuilder:2 } },
        { text: 'None of these',                             scores: {}, exclusive: true }
      ]
    },
    {
      id: 4,
      text: 'How long have you been dealing with digestive symptoms?',
      type: 'single',
      options: [
        { text: 'Less than 6 months',              scores: {} },
        { text: '6 months to 2 years',             scores: { rebuilder:1 } },
        { text: '2 to 5 years',                    scores: { rebuilder:2 } },
        { text: 'More than 5 years',               scores: { rebuilder:3 } },
        { text: 'Honestly, it feels like forever', scores: { rebuilder:3 } }
      ]
    },
    {
      id: 5,
      text: 'What are you hoping to improve most right now?',
      hint: 'Choose up to 2.',
      type: 'multi',
      maxSelect: 2,
      options: [
        { text: 'Reduce bloating and pressure',                       scores: { fermenter:3 } },
        { text: 'Feel lighter and more comfortable after eating',     scores: { stalled:2, fermenter:1 } },
        { text: 'Improve digestive movement and regularity',          scores: { stalled:4 } },
        { text: 'Understand what may be causing my symptoms',         scores: { rebuilder:3 } },
        { text: 'Restore balance naturally',                          scores: { rebuilder:3 } },
        { text: 'Support long-term gut health',                       scores: { rebuilder:4 } },
        { text: 'Reduce digestive discomfort',                        scores: { fermenter:1, stalled:1, reactive:1 } },
        { text: 'Improve my energy and mental clarity',              scores: { rebuilder:1 } },
        { text: 'Feel more confident in daily life',                  scores: { reactive:1, rebuilder:1 } },
        { text: 'Stop thinking about my digestion all the time',      scores: { reactive:2, rebuilder:2 } }
      ]
    },
    {
      id: 6,
      text: 'Which statement sounds most like you?',
      hint: 'Optional, but it helps us personalise your result.',
      type: 'single',
      optional: true,
      options: [
        { text: '\u201cHealthy foods seem to make me feel worse.\u201d',    scores: { fermenter:4 } },
        { text: '\u201cI constantly feel heavy or backed up.\u201d',        scores: { stalled:4 } },
        { text: '\u201cMy symptoms change all the time.\u201d',             scores: { reactive:4 } },
        { text: '\u201cI feel like my gut has been through a lot.\u201d',   scores: { rebuilder:4 } },
        { text: '\u201cI\u2019m tired of temporary fixes.\u201d',           scores: { rebuilder:3 } },
        { text: '\u201cI don\u2019t even know where to start anymore.\u201d', scores: { rebuilder:2 } }
      ]
    },
    {
      id: 7,
      text: 'Help Dr. Brown personalize your recommendations. Have you used any of the following to support your digestive health?',
      hint: 'Select all that apply.',
      type: 'multi',
      infoOnly: true, /* does not affect archetype scoring */
      options: [
        { label: 'Regarding Your Gut Products' },
        { text: 'Atrantil',  scores: {} },
        { text: 'Re:flux',   scores: {} },
        { label: 'For Acid Reflux or Heartburn' },
        { text: 'Antacids (e.g. Tums, Gaviscon, Rolaids)',                                            scores: {} },
        { text: 'Acid-blocking medications (e.g. Nexium, Prilosec, Prevacid, Pepcid)',                scores: {} },
        { label: 'For Constipation' },
        { text: 'Laxatives (e.g. MiraLAX, RestoraLAX, Senokot, Dulcolax, Milk of Magnesia)',          scores: {} },
        { text: 'Prescription constipation medications (e.g. Linzess, Trulance, Amitiza, Motegrity)', scores: {} },
        { label: 'Other Gut Support' },
        { text: 'Probiotics',                                                                          scores: {} },
        { text: 'Digestive enzymes',                                                                   scores: {} },
        { text: 'Fiber or psyllium (e.g. Metamucil, Benefiber)',                                       scores: {} },
        { text: 'Magnesium supplements',                                                               scores: {} },
        { text: 'Other digestive supplements',                                                         scores: {} },
        { label: 'Other' },
        { text: 'None of the above',  scores: {}, exclusive: true },
        { text: 'Prefer not to say',  scores: {}, exclusive: true }
      ]
    },
    {
      id: 8,
      text: 'Are you currently taking a GLP-1 medication?',
      intro: 'GLP-1 medications can affect digestion and are associated with symptoms like reflux, bloating, constipation, and, in some people, SIBO. Knowing if you\u2019re taking one helps Dr. Brown better personalize your results.',
      type: 'single',
      optional: true,
      infoOnly: true,
      options: [
        { text: 'Yes',               scores: {} },
        { text: 'No',                scores: {} },
        { text: 'Prefer not to say', scores: {} }
      ]
    }
  ];

  /* ═══════════════════════════════════════════════════════════
     ARCHETYPE DEFINITIONS
  ═══════════════════════════════════════════════════════════ */

  var BASE = 'https://regardingyourgut.com';

  var ARCHETYPES = {
    fermenter: {
      theme:   'qv2-theme-fermenter',
      eyebrow: 'Your Gut Archetype',
      name:    'The Fermenter',
      pattern: 'Gas \u00b7 Bloating \u00b7 Pressure \u00b7 Distention',
      desc:    'Your answers suggest patterns commonly associated with microbial fermentation and digestive gas buildup in the gut. This is one of the most common digestive patterns \u2014 and one of the most misunderstood. The discomfort is real, and it\u2019s a signal worth paying attention to.',
      videoTitle: 'FERMENTER GUT QUIZ',
      signs: [
        'Bloating after meals',
        'Feeling \u201cpregnant\u201d by the evening',
        'Excess gas and pressure',
        'Symptoms worse after carbohydrates or fiber',
        'Constipation or slowed transit'
      ],
      learn: [
        { text: 'What causes gas and bloating?',           href: BASE + '/pages/what-causes-bloating' },
        { text: 'Understanding fermentation in the gut',   href: BASE + '/blogs/journal/archaea-vs-bacteria-what-s-the-difference' },
        { text: 'The root cause of SIBO and IBS',          href: BASE + '/blogs/journal/atrantil-getting-to-the-root-cause-of-your-sibo-and-ibs' },
        { text: 'Why your bloating is not going away',     href: BASE + '/blogs/journal/why-your-bloating-is-not-going-away' }
      ]
    },
    stalled: {
      theme:   'qv2-theme-stalled',
      eyebrow: 'Your Gut Archetype',
      name:    'The Stalled Gut',
      pattern: 'Slow Movement \u00b7 Fullness \u00b7 Heaviness',
      desc:    'Your answers suggest your digestive system may need support with movement and flow. When digestion slows down, everything feels heavier \u2014 food sits longer, energy dips, and discomfort builds. The goal is restoring natural rhythm, not forcing it.',
      videoTitle: 'STALLED GUT QUIZ',
      signs: [
        'Feeling full quickly after eating',
        'Food sitting heavily in your stomach',
        'Sluggish digestion throughout the day',
        'Constipation or infrequent bowel movements',
        'Symptoms that get worse as the day goes on'
      ],
      learn: [
        { text: 'Constipation: causes and how to stop it',       href: BASE + '/blogs/journal/constipation-causes-and-how-to-stop-it' },
        { text: 'Constipation issues as seen in the clinic',     href: BASE + '/blogs/journal/constipation-issues-as-seen-in-the-clinic' },
        { text: 'How to naturally get rid of bloating for good', href: BASE + '/blogs/journal/all-about-the-bloat-how-to-naturally-get-rid-of-bloating-for-good' }
      ]
    },
    reactive: {
      theme:   'qv2-theme-reactive',
      eyebrow: 'Your Gut Archetype',
      name:    'The Reactive Gut',
      pattern: 'Sensitivity \u00b7 Inconsistency \u00b7 Fluctuation',
      desc:    'Your symptoms may reflect a digestive system that reacts strongly to food, stress, or lifestyle changes. The unpredictability is part of the pattern \u2014 good days and bad days, with no clear single cause. The gut-brain connection plays a significant role here.',
      videoTitle: 'REACTIVE GUT QUIZ',
      signs: [
        'Symptoms that seem unpredictable',
        'Strong food sensitivities',
        'Stress-related digestive flares',
        'Fluctuating good days and bad days',
        'Discomfort without an obvious trigger'
      ],
      learn: [
        { text: 'SIBO and brain fog',                      href: BASE + '/blogs/journal/sibo-and-brain-fog' },
        { text: 'SIBO and histamine intolerance',          href: BASE + '/blogs/journal/sibo-histamine-intolerance-what-s-the-connection' },
        { text: 'Which microbes cause IBS subtypes',       href: BASE + '/blogs/journal/new-research-shows-which-microbes-cause-ibs-subtypes' }
      ]
    },
    rebuilder: {
      theme:   'qv2-theme-rebuilder',
      eyebrow: 'Your Gut Archetype',
      name:    'The Rebuilder',
      pattern: 'Restoration \u00b7 Resilience \u00b7 Root Cause',
      desc:    'You may be in a rebuilding phase \u2014 after long-term digestive struggles, medications, stress, or repeated approaches that only managed symptoms temporarily. This archetype is about going deeper, not just feeling better for a few weeks.',
      videoTitle: 'REBUILDER GUT QUIZ',
      signs: [
        'Long digestive history with recurring issues',
        'Frustration with temporary fixes',
        'Symptoms that keep returning',
        'A desire to understand the root cause',
        'Feeling disconnected from your own body'
      ],
      learn: [
        { text: 'How to fix gut dysbiosis naturally',     href: BASE + '/blogs/journal/how-to-fix-gut-dysbiosis-naturally' },
        { text: '16 ways to support your microbiome',    href: BASE + '/blogs/journal/how-to-heal-gut-health-naturally-16-ways-to-support-your-microbiome' },
        { text: '6 reasons to choose Atrantil',          href: BASE + '/blogs/journal/6-reasons-you-should-choose-atrantil' }
      ]
    }
  };

  /* Klaviyo-safe archetype labels — must match exactly */
  var ARCHETYPE_LABEL = {
    fermenter: 'Fermenter',
    stalled:   'Stalled',
    reactive:  'Reactive',
    rebuilder: 'Rebuilder'
  };

  /* Reflux Severity labels for Klaviyo profile property */
  function refluxSeverityLabel(flag) {
    if (flag === 'high') return 'High';
    if (flag === 'some') return 'Some';
    return 'None';
  }

  /* ═══════════════════════════════════════════════════════════
     PRODUCT BLOCK LOGIC
     reflux_none  → Atrantil hero
     reflux_some  → Atrantil hero + Re:flux secondary
     reflux_high  → Re:flux hero
                    Fermenter/Stalled: Re:flux + Atrantil (both relevant)
                    Reactive/Rebuilder: Re:flux primary
  ═══════════════════════════════════════════════════════════ */

  function getProductBlock(winner, refluxFlag, urls) {
    var a = urls.atrantil      || BASE + '/products/atrantil';
    var r = urls.refluxWaitlist || BASE + '/pages/re-flux';
    var h = urls.atrantilHow   || BASE + '/pages/how-atrantil-works';

    if (refluxFlag === 'none') {
      return {
        eyebrow: 'Recommended for You',
        heading: 'Atrantil',
        desc: 'Atrantil is a polyphenol-powered formula that targets the archaebacteria responsible for fermentation, bloating, and gas in the small intestine \u2014 addressing the root cause rather than masking symptoms.',
        actions: [
          { label: 'Shop Atrantil', href: a, primary: true },
          { label: 'How it works',  href: h, primary: false }
        ]
      };
    }

    if (refluxFlag === 'some') {
      return {
        eyebrow: 'Recommended for You',
        heading: 'Atrantil \u2014 with Re:flux coming',
        desc: 'Atrantil is your primary recommendation based on your gut pattern. Your answers also show some upper digestive involvement \u2014 Re:flux is designed to address the acid reflux mechanism directly and will be a strong pairing. Coming soon.',
        waitlist: true,
        waitlistLabel: 'Re:flux \u2014 Coming Soon',
        actions: [
          { label: 'Shop Atrantil',           href: a, primary: true },
          { label: 'Join Re:flux Waitlist',   href: r, primary: false }
        ]
      };
    }

    /* reflux_high — same for all archetypes */
    return {
      eyebrow: 'Your Recommended Protocol',
      heading: 'Re:flux + Atrantil',
      desc: 'Your results show significant upper digestive involvement alongside your gut symptoms. Re:flux addresses the acid reflux mechanism directly. Atrantil targets the fermentation and motility patterns driving your other symptoms. Both are relevant \u2014 and work together.',
      waitlist: true,
      waitlistLabel: 'Re:flux \u2014 Coming Soon',
      actions: [
        { label: 'Join Re:flux Waitlist',  href: r, primary: true },
        { label: 'Shop Atrantil',          href: a, primary: false }
      ]
    };
  }

  /* ═══════════════════════════════════════════════════════════
     SCORING
  ═══════════════════════════════════════════════════════════ */

  function calcScores(answers) {
    var sc = { fermenter:0, stalled:0, reactive:0, rebuilder:0, reflux:0 };
    var step6Archetype = null;

    QUESTIONS.forEach(function (q, qi) {
      var ans = answers[qi];
      if (ans === null || ans === undefined) return;

      /* Selectable options exclude category label items (Q7 has these).
         Selected indices refer to this filtered list, not q.options. */
      var selectableOpts = q.options.filter(function (o) { return !o.label; });

      function add(s) {
        if (!s) return; /* guard: labels and score-less options */
        Object.keys(s).forEach(function (k) { sc[k] = (sc[k] || 0) + s[k]; });
      }

      if (q.type === 'multi') {
        (ans || []).forEach(function (i) {
          var opt = selectableOpts[i];
          if (opt) add(opt.scores);
        });
      } else {
        var chosen = selectableOpts[ans];
        if (!chosen) return;
        add(chosen.scores);

        /* Q6 (index 5) contributes the tiebreaker archetype */
        if (qi === 5) {
          var s = chosen.scores || {};
          var archs = ['fermenter','stalled','reactive','rebuilder'];
          var best = null, bestVal = 0;
          archs.forEach(function (a) { if ((s[a]||0) > bestVal) { bestVal = s[a]||0; best = a; } });
          step6Archetype = best;
        }
      }
    });

    return { scores: sc, step6Archetype: step6Archetype };
  }

  function pickArchetype(scores, step6Archetype) {
    var archs = ['fermenter','stalled','reactive','rebuilder'];
    var max = 0;
    archs.forEach(function (a) { if (scores[a] > max) max = scores[a]; });
    var tied = archs.filter(function (a) { return scores[a] === max; });
    if (tied.length === 1) return tied[0];
    if (step6Archetype && tied.indexOf(step6Archetype) > -1) return step6Archetype;
    var priority = ['reactive','fermenter','stalled','rebuilder'];
    for (var p = 0; p < priority.length; p++) {
      if (tied.indexOf(priority[p]) > -1) return priority[p];
    }
    return tied[0];
  }

  function getRefluxFlag(score) {
    if (score >= 12) return 'high';
    if (score >= 7)  return 'some';
    return 'none';
  }

  /* ═══════════════════════════════════════════════════════════
     KLAVIYO
     Uses only the public-key client/ endpoints (safe for browser).
     Step 1: set Gut Archetype on profile (must happen FIRST).
     Step 2: subscribe to list (triggers the Klaviyo flow).
  ═══════════════════════════════════════════════════════════ */

  function submitToKlaviyo(config, email, firstName, archetype, refluxFlag, onSuccess, onError) {
    var publicKey = config.klaviyoPublicKey;
    var listId    = config.klaviyoListId || 'TC7fUV';

    if (!publicKey) {
      console.warn('[RYG Quiz] Klaviyo public key not set — skipping API call.');
      onSuccess();
      return;
    }

    var label   = ARCHETYPE_LABEL[archetype] || archetype;
    var reflux  = refluxSeverityLabel(refluxFlag);
    var headers = { 'Content-Type': 'application/json', 'revision': '2024-02-15' };

    /* 1. Subscribe payload.
          Klaviyo rejects a 'subscriptions' block inside the nested profile at
          revision 2024-02-15 ("'subscriptions' is not a valid field for the
          resource 'profile'"). POSTing to /client/subscriptions/ IS the opt-in
          action — consent is recorded per the list's own opt-in settings. */
    var subscribeBody = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Gut Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    });

    /* 2. Profile payload — stamps name and archetype properties. */
    var profileBody = JSON.stringify({
      data: {
        type: 'profile',
        attributes: {
          email: email,
          first_name: firstName || '',
          properties: {
            'Gut Archetype':   label,
            'Reflux Severity': reflux
          }
        }
      }
    });

    /* fetch() resolves on 4xx/5xx — check res.ok explicitly or failures vanish. */
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: headers, body: body })
        .then(function (res) {
          if (!res.ok) {
            return res.text().then(function (t) {
              /* Surface Klaviyo's specific error detail, which names the bad field */
              var detail = t;
              try {
                var parsed = JSON.parse(t);
                if (parsed.errors && parsed.errors.length) {
                  detail = parsed.errors.map(function (e) {
                    return (e.detail || e.title || '') +
                           (e.source && e.source.pointer ? ' [' + e.source.pointer + ']' : '');
                  }).join(' | ');
                }
              } catch (e) { /* not JSON — use raw text */ }

              var err = new Error('Klaviyo ' + res.status + ' — ' + detail);
              err.status  = res.status;
              err.rawBody = t;
              throw err;
            });
          }
          return res;
        });
    }

    var subUrl     = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey;
    var profileUrl = 'https://a.klaviyo.com/client/profiles/?company_id=' + publicKey;

    /* Subscribe FIRST (records the opt-in), then stamp properties. */
    post(subUrl, subscribeBody)
      .then(function () {
        return post(profileUrl, profileBody);
      })
      .then(function () {
        console.log('[RYG Quiz] Klaviyo subscribe + profile succeeded.');
        onSuccess();
      })
      .catch(function (err) {
        console.error('[RYG Quiz] Klaviyo failed:', err.message);
        if (err.rawBody) console.error('[RYG Quiz] Full response body:', err.rawBody);
        /* Never block the user from seeing their result. */
        if (typeof onError === 'function') { onError(err); } else { onSuccess(); }
      });
  }

  /* ═══════════════════════════════════════════════════════════
     INSTANCE FACTORY
  ═══════════════════════════════════════════════════════════ */

  function RYGQuizV2Instance(config) {
    var SID = config.sectionId;

    /* DOM helpers */
    function el(suffix)  { return document.getElementById(suffix + '-' + SID); }
    function root()      { return document.getElementById('ryg-qv2-' + SID); }

    /* State */
    var state = { step: 0, answers: [], emailStep: false, result: null };
    QUESTIONS.forEach(function () { state.answers.push(null); });

    /* Session ID for analytics tracking */
    var sessionId = 'ryg_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);

    /* ── Fire-and-forget event to Mac Mini API ── */
    function trackEvent(endpoint, data) {
      var apiUrl = config.apiEndpoint;
      if (!apiUrl) return; /* gracefully skip if not configured */
      fetch(apiUrl + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).catch(function () {}); /* never block the UX */
    }

    /* ── Render a question step ── */
    function render() {
      var progressEl = el('qv2Progress');
      var labelEl    = el('qv2ProgressLabel');
      var container  = el('qv2Container');
      var navEl      = el('qv2Nav');

      if (!container) {
        console.error('[RYG Quiz] Cannot find #qv2Container-' + SID + '. Check that the section ID in the liquid matches the JS config.');
        return;
      }

      var q   = QUESTIONS[state.step];
      var ans = state.answers[state.step];
      var pct = (state.step / QUESTIONS.length) * 100;

      if (progressEl) progressEl.style.width = pct + '%';
      if (labelEl)    labelEl.textContent = 'Question ' + (state.step + 1) + ' of ' + QUESTIONS.length;

      var html = '<div class="qv2-step">';
      html += '<div class="qv2-q-number">Question ' + (state.step + 1) + ' of ' + QUESTIONS.length + '</div>';
      if (q.intro) html += '<div class="qv2-q-intro">' + q.intro + '</div>';
      html += '<div class="qv2-q-text">' + q.text + '</div>';
      if (q.hint) html += '<div class="qv2-q-hint">' + q.hint + '</div>';

      if (q.type === 'multi') {
        var sel = ans || [];
        var maxHit = !!(q.maxSelect && sel.length >= q.maxSelect);
        html += '<div class="qv2-chips">';
        var selectableIdx = 0;
        q.options.forEach(function (opt) {
          /* Category label — non-interactive separator */
          if (opt.label) {
            html += '<div class="qv2-category-label">' + opt.label + '</div>';
            return;
          }
          var i     = selectableIdx++;
          var isSel = sel.indexOf(i) > -1;
          var dis   = !isSel && maxHit;
          html += '<button class="qv2-chip' + (isSel ? ' selected' : '') + (dis ? ' disabled' : '') + '" '
               + 'data-qv2-q="' + state.step + '" data-qv2-i="' + i + '" type="button">'
               + '<span class="qv2-chip-dot"></span>' + opt.text + '</button>';
        });
        html += '</div>';
      } else {
        html += '<div class="qv2-options">';
        var optIdx = 0;
        q.options.forEach(function (opt) {
          if (opt.label) {
            html += '<div class="qv2-category-label">' + opt.label + '</div>';
            return;
          }
          var i = optIdx++;
          html += '<button class="qv2-option' + (ans === i ? ' selected' : '') + '" '
               + 'data-qv2-q="' + state.step + '" data-qv2-i="' + i + '" type="button">'
               + '<span class="qv2-option-radio"></span>' + opt.text + '</button>';
        });
        html += '</div>';
      }
      html += '</div>';

      container.innerHTML = html;

      /* Only scroll after user navigates — not on initial load */
      if (state.step > 0) {
        container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      /* ── Attach direct listeners to every chip (multi-select) ── */
      container.querySelectorAll('.qv2-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (chip.classList.contains('disabled')) return;

          var qi          = parseInt(chip.getAttribute('data-qv2-q'), 10);
          var selectableI = parseInt(chip.getAttribute('data-qv2-i'), 10);
          var q           = QUESTIONS[qi];

          /* Selectable options are those without a label property */
          var selectableOpts = q.options.filter(function (o) { return !o.label; });
          var opt            = selectableOpts[selectableI];
          if (!opt) return;

          var sel = Array.isArray(state.answers[qi]) ? state.answers[qi].slice() : [];

          /* Find exclusive option index within selectable list */
          var noneIdx = -1;
          selectableOpts.forEach(function (o, si) { if (o.exclusive) noneIdx = si; });

          if (opt.exclusive) {
            sel = sel.indexOf(selectableI) > -1 ? [] : [selectableI];
          } else {
            if (noneIdx > -1) sel = sel.filter(function (x) { return x !== noneIdx; });
            var pos = sel.indexOf(selectableI);
            if (pos > -1) {
              sel.splice(pos, 1);
            } else {
              if (!q.maxSelect || sel.length < q.maxSelect) sel.push(selectableI);
            }
          }

          state.answers[qi] = sel;

          /* Update every chip's visual state */
          var maxHit = !!(q.maxSelect && sel.length >= q.maxSelect);
          container.querySelectorAll('.qv2-chip[data-qv2-q="' + qi + '"]').forEach(function (c) {
            var ci    = parseInt(c.getAttribute('data-qv2-i'), 10);
            var isSel = sel.indexOf(ci) > -1;
            var isExcl = selectableOpts[ci] && selectableOpts[ci].exclusive;
            c.classList.toggle('selected', isSel);
            c.classList.toggle('disabled', !isSel && !isExcl && maxHit);
          });

          var bn = el('qv2Next');
          if (bn) bn.disabled = (sel.length === 0 && !q.optional);
        });
      });

      /* ── Attach direct listeners to every option (single-select) ── */
      container.querySelectorAll('.qv2-option').forEach(function (option) {
        option.addEventListener('click', function () {
          var qi2  = parseInt(option.getAttribute('data-qv2-q'), 10);
          var idx2 = parseInt(option.getAttribute('data-qv2-i'), 10);
          var cur  = state.answers[qi2];
          var nv   = (cur === idx2) ? null : idx2;
          state.answers[qi2] = nv;

          container.querySelectorAll('.qv2-option[data-qv2-q="' + qi2 + '"]').forEach(function (o) {
            o.classList.toggle('selected', parseInt(o.getAttribute('data-qv2-i'), 10) === nv);
          });

          var bn2 = el('qv2Next');
          if (bn2) bn2.disabled = (nv === null);
        });
      });

      /* Nav */
      var canGo = q.optional ? true
        : q.type === 'multi' ? (ans && ans.length > 0)
        : (ans !== null && ans !== undefined);

      var nav = '';
      if (state.step > 0) {
        nav += '<button class="qv2-btn-back" id="qv2Back-' + SID + '" type="button">'
             + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Back</button>';
      } else {
        nav += '<span></span>';
      }
      if (q.optional) {
        nav += '<button class="qv2-btn-skip" id="qv2Skip-' + SID + '" type="button">Skip</button>';
      }
      var isLast = state.step === QUESTIONS.length - 1;
      nav += '<button class="qv2-btn-next" id="qv2Next-' + SID + '" type="button"' + (canGo ? '' : ' disabled') + '>'
           + (isLast ? 'See My Results \u2192' : 'Continue \u2192') + '</button>';

      if (navEl) navEl.innerHTML = nav;

      var bb = el('qv2Back');
      var bs = el('qv2Skip');
      var bn = el('qv2Next');
      if (bb) bb.addEventListener('click', goBack);
      if (bs) bs.addEventListener('click', function () { advance(true); });
      if (bn) bn.addEventListener('click', function () { advance(false); });
    }

    /* ── Step navigation ── */
    function advance(skip) {
      if (!skip) {
        var q   = QUESTIONS[state.step];
        var ans = state.answers[state.step];
        if (!q.optional) {
          var valid = q.type === 'multi' ? (ans && ans.length > 0) : (ans !== null);
          if (!valid) return;
        }
      }

      /* Track this answer before moving on */
      trackEvent('/quiz/answer', {
        session_id:      sessionId,
        question_number: state.step + 1,
        question_text:   QUESTIONS[state.step].text,
        selected_answers: state.answers[state.step]
      });

      if (state.step < QUESTIONS.length - 1) {
        state.step++;
        render();
      } else {
        showEmailCapture(); /* gate before redirect */
      }
    }

    function goBack() {
      if (state.step > 0) { state.step--; render(); }
    }

    /* ── Email capture step — shown after Q6, before redirect ── */
    function showEmailCapture() {
      /* Pre-calculate result so we have it ready */
      var result     = calcScores(state.answers);
      var winner     = pickArchetype(result.scores, result.step6Archetype);
      var refluxFlag = getRefluxFlag(result.scores.reflux || 0);
      state.result   = { winner: winner, refluxFlag: refluxFlag };
      state.emailStep = true;

      /* Progress bar → 100% */
      var progressEl = el('qv2Progress');
      var labelEl    = el('qv2ProgressLabel');
      if (progressEl) progressEl.style.width = '100%';
      if (labelEl)    labelEl.textContent = 'Almost there';

      var container = el('qv2Container');
      if (!container) return;

      container.innerHTML = '<div class="qv2-step">'
        + '<div class="qv2-q-number">Last Step</div>'
        + '<div class="qv2-q-text">Get Your Personalized Gut Plan From Dr. Brown</div>'
        + '<div class="qv2-q-hint">Enter your details to receive your archetype results, recommended resources, and early access to new products tailored to your gut pattern.</div>'
        + '<div class="qv2-email-fields">'
        + '<input class="qv2-field-input" type="text"  id="qv2FN-' + SID + '" placeholder="First name" autocomplete="given-name">'
        + '<input class="qv2-field-input" type="email" id="qv2EM-' + SID + '" placeholder="your@email.com" autocomplete="email">'
        + '</div>'
        + '<label class="qv2-consent-row">'
        + '<input type="checkbox" class="qv2-consent-check" id="qv2Consent-' + SID + '">'
        + '<span class="qv2-consent-label">I agree to Regarding Your Gut using my quiz answers, including health information, to personalize my results and send me related emails. I can withdraw my consent anytime. '
        + '<a href="' + (config.consumerHealthPolicyUrl || '/pages/privacy-policy') + '" target="_blank" class="qv2-policy-link">Consumer Health Data Privacy Policy</a>.'
        + '</span>'
        + '</label>'
        + '<p class="qv2-email-note">No spam. Unsubscribe anytime. Your results are saved to your inbox.</p>'
        + '</div>';

      /* Nav: Back + Get My Results */
      var navEl = el('qv2Nav');
      if (navEl) {
        navEl.innerHTML =
          '<button class="qv2-btn-back" id="qv2EmailBack-' + SID + '" type="button">'
          + '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg> Back</button>'
          + '<button class="qv2-btn-next" id="qv2EmailSubmit-' + SID + '" type="button">Get My Results \u2192</button>';

        var backBtn   = document.getElementById('qv2EmailBack-'   + SID);
        var submitBtn = document.getElementById('qv2EmailSubmit-' + SID);

        if (backBtn) backBtn.addEventListener('click', function () {
          state.emailStep = false;
          state.step = QUESTIONS.length - 1;
          render();
        });

        if (submitBtn) {
          submitBtn.addEventListener('click', function () {
            var emailEl   = document.getElementById('qv2EM-'      + SID);
            var fnEl      = document.getElementById('qv2FN-'      + SID);
            var consentEl = document.getElementById('qv2Consent-' + SID);
            var email   = emailEl   ? emailEl.value.trim()   : '';
            var fn      = fnEl      ? fnEl.value.trim()      : '';

            if (!email || !email.includes('@')) {
              if (emailEl) emailEl.focus();
              return;
            }

            if (consentEl && !consentEl.checked) {
              consentEl.closest('.qv2-consent-row').classList.add('qv2-consent-error');
              return;
            }

            submitBtn.disabled    = true;
            submitBtn.textContent = 'Getting your results\u2026';

            /* Log completion to analytics API */
            trackEvent('/quiz/complete', {
              session_id:       sessionId,
              archetype_result: winner,
              reflux_severity:  refluxSeverityLabel(refluxFlag),
              email:            email,
              first_name:       fn
            });

            /* Guard against double-redirect */
            var redirected = false;
            function safeRedirect() {
              if (redirected) return;
              redirected = true;
              doRedirect(winner, refluxFlag);
            }

            /* Klaviyo — subscribe (records consent) THEN stamp properties, THEN redirect */
            submitToKlaviyo(config, email, fn, winner, refluxFlag, safeRedirect, safeRedirect);

            /* Safety net: redirect after 4s even if Klaviyo is slow */
            setTimeout(safeRedirect, 4000);
          });

          /* Allow Enter key in email field */
          var emailEl = document.getElementById('qv2EM-' + SID);
          if (emailEl) emailEl.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') submitBtn.click();
          });
        }
      }
    }

    /* ── Redirect to the correct archetype page ── */
    function doRedirect(winner, refluxFlag) {
      var pages       = config.resultPages  || {};
      var refluxPages = config.refluxPages  || {};

      var defaults = {
        fermenter: '/pages/the-fermenter',
        stalled:   '/pages/the-stalled-gut',
        reactive:  '/pages/the-reactive-gut',
        rebuilder: '/pages/the-rebuilder'
      };
      var refluxDefaults = {
        fermenter: '/pages/archetype-fermenter-reflux',
        stalled:   '/pages/archetype-stalled-reflux',
        reactive:  '/pages/archetype-reactive-reflux',
        rebuilder: '/pages/archetype-rebuilder-reflux'
      };

      var hasReflux   = (refluxFlag === 'some' || refluxFlag === 'high');
      var destination = hasReflux
        ? (refluxPages[winner] || refluxDefaults[winner])
        : (pages[winner]       || defaults[winner]);

      window.location.href = destination;
    }


    /* ── Intro consent notice — shown before Q1 ── */
    function renderIntro() {
      var progressEl = el('qv2Progress');
      var labelEl    = el('qv2ProgressLabel');
      var container  = el('qv2Container');
      var navEl      = el('qv2Nav');
      if (!container) return;

      if (progressEl) progressEl.style.width = '0%';
      if (labelEl)    labelEl.textContent = 'Before we begin';

      container.innerHTML = '<div class="qv2-step">'
        + '<div class="qv2-q-number">Before We Begin</div>'
        + '<div class="qv2-q-text">A few quick questions so Dr. Brown can personalize your result.</div>'
        + '<div class="qv2-intro-notice">'
        + 'These questions include some health information so Dr. Brown can personalize your result. '
        + 'Answering is optional, and we never sell your health information or use it to target ads. '
        + 'By continuing, you agree to our '
        + '<a href="' + (config.privacyPolicyUrl || '/pages/privacy-policy') + '" target="_blank" class="qv2-policy-link">Privacy Policy</a>'
        + ' and '
        + '<a href="' + (config.consumerHealthPolicyUrl || '/pages/privacy-policy') + '" target="_blank" class="qv2-policy-link">Consumer Health Data Privacy Policy</a>.'
        + '</div>'
        + '</div>';

      if (navEl) {
        navEl.innerHTML = '<span></span>'
          + '<button class="qv2-btn-next" id="qv2IntroNext-' + SID + '" type="button">Start the Quiz \u2192</button>';
        var startBtn = document.getElementById('qv2IntroNext-' + SID);
        if (startBtn) startBtn.addEventListener('click', function () { render(); });
      }
    }

    /* ── Attach event delegation & init ── */
    function init() {
      var sectionRoot = root();
      if (!sectionRoot) {
        console.error('[RYG Quiz] Section root #ryg-qv2-' + SID + ' not found in DOM.');
        return;
      }
      console.log('[RYG Quiz] Initialising instance:', SID);

      /* Start analytics session */
      trackEvent('/quiz/start', {
        session_id: sessionId,
        started_at: new Date().toISOString(),
        user_agent: navigator.userAgent
      });

      renderIntro(); /* show consent notice before Q1 */
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  /* ═══════════════════════════════════════════════════════════
     BOOT — init every instance on the page
  ═══════════════════════════════════════════════════════════ */

  function boot() {
    var instances = window.RYGQuizV2 || {};
    Object.keys(instances).forEach(function (id) {
      RYGQuizV2Instance(instances[id]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();